// roomConfig.js
// One entry per "room" the user can navigate into.
//
// entryAreaId    = the waypoint Id (in the PARENT room) that triggers entering this room — shown as UP arrow
// exitAreaId     = a specific waypoint Id (inside THIS room) that exits back to the parent — shown as UP arrow
//                  (use null to allow exiting from ANY waypoint — shown as DOWN arrow, e.g. leaf Schaustellen)
// downExitAreaId = OPTIONAL extra specific waypoint Id (inside THIS room) that ALSO exits back to the
//                  parent, but shown as the DOWN arrow instead of the up arrow (e.g. the landing waypoint)
export const ROOM_CONFIG = {
  EntryRoom: {
    loader: () => import("../EntryRoom/states/waypointsEntryRoom.json"),
    parentId: null,
    entryAreaId: null,
    exitAreaId: null,
    downExitAreaId: null,
  },

  // Level 2: Theme overview room
  ThemeM_Salzabbau: {
    loader: () => import("../EntryRoom/states/waypointsSalzabbau.json"),
    parentId: "EntryRoom",
    entryAreaId: "ThemeM_Salzabbau",
    exitAreaId: "Salzabbau_Exit",       // exits via the UP arrow
    downExitAreaId: "Salzabbau_Entry",  // ALSO exits via the DOWN arrow, only here
  },

  ThemeM_Menschen: {
    loader: () => import("../EntryRoom/states/waypointsMenschen.json"),
    parentId: "EntryRoom",
    entryAreaId: "ThemeM_Menschen",
    exitAreaId: "Menschen_Exit",
    downExitAreaId: "Menschen_Entry",
  },
  ThemeM_Handelswege: {
    loader: () => import("../EntryRoom/states/waypointsHandelswege.json"),
    parentId: "EntryRoom",
    entryAreaId: "ThemeM_Handelswege",
    exitAreaId: "Handelswege_Exit",
    downExitAreaId: "MainInfo_Salztransport",
  },
  ThemeM_Klima: {
    loader: () => import("../EntryRoom/states/waypointsKlima.json"),
    parentId: "EntryRoom",
    entryAreaId: "ThemeM_Klima",
    exitAreaId: "Klima_Exit",
    downExitAreaId: "Klima_Entry",
  },
  ThemeM_Holzarbeit: {
    loader: () => import("../EntryRoom/states/waypointsHolzarbeit.json"),
    parentId: "EntryRoom",
    entryAreaId: "ThemeM_Holzarbeit",
    exitAreaId: "Holzarbeit_Exit",
    downExitAreaId: "Holzarbeit_Entry",
  },

  // Level 3: Schaustellen — entered from the Salzabbau overview, exit from anywhere inside
  salzEnt: {
    loader: () => import("../EntryRoom/states/waypointsSalzent.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_SalzEnt",
    exitAreaId: null,
    downExitAreaId: null,
  },
  wSetBronzezeit: {
    loader: () => import("../EntryRoom/states/waypointsBronzezeit.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_Bronzezeit",
    exitAreaId: null,
    downExitAreaId: null,
  },
  wSetSteinzeit: {
    loader: () => import("../EntryRoom/states/waypointsSteinzeit.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_Steinzeit",
    exitAreaId: null,
    downExitAreaId: null,
  },
  wSetEisenzeit: {
    loader: () => import("../EntryRoom/states/waypointsEisenzeit.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_Eisenzeit",
    exitAreaId: null,
    downExitAreaId: null,
  },
  wSetMittelalter: {
    loader: () => import("../EntryRoom/states/waypointsMittelalter.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_Sohle",
    exitAreaId: null,
    downExitAreaId: null,
  },
  wSetModernerBergbau: {
    loader: () => import("../EntryRoom/states/waypointsModernerBergbau.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_Bergbau",
    exitAreaId: null,
    downExitAreaId: null,
  },
  wSetTourismus: {
    loader: () => import("../EntryRoom/states/waypointsTourismus.json"),
    parentId: "ThemeM_Salzabbau",
    entryAreaId: "Salzabbau_Salzwelten",
    exitAreaId: null,
    downExitAreaId: null,
  },

  // Level 3: Schaustellen — entered from the Menschen overview, exit from anywhere inside
  mBergarbeiter: {
    loader: () => import("../EntryRoom/states/waypointsBergarbeiter.json"),
    parentId: "ThemeM_Menschen",
    entryAreaId: "Menschen_Zeitmaschine",
    exitAreaId: null,
    downExitAreaId: null,
  },
  mArbeitswelt: {
    loader: () => import("../EntryRoom/states/waypointsMenschenArbeitswelt.json"),
    parentId: "ThemeM_Menschen",
    entryAreaId: "Menschen_Arbeitswelt",
    exitAreaId: null,
    downExitAreaId: null,
  },
  mHeimat: {
    loader: () => import("../EntryRoom/states/waypointsMenschenHeimat.json"),
    parentId: "ThemeM_Menschen",
    entryAreaId: "Menschen_Heimat",
    exitAreaId: null,
    downExitAreaId: null,
  },
  mGlaube: {
    loader: () => import("../EntryRoom/states/waypointsMenschenGlaube.json"),
    parentId: "ThemeM_Menschen",
    entryAreaId: "Menschen_Glaube",
    exitAreaId: null,
    downExitAreaId: null,
  },
  mMacht: {
    loader: () => import("../EntryRoom/states/waypointsMenschenMacht.json"),
    parentId: "ThemeM_Menschen",
    entryAreaId: "Menschen_Macht",
    exitAreaId: null,
    downExitAreaId: null,
  },
  mGewalt: {
    loader: () => import("../EntryRoom/states/waypointsMenschenGewalt.json"),
    parentId: "ThemeM_Menschen",
    entryAreaId: "Menschen_Gewalt",
    exitAreaId: null,
    downExitAreaId: null,
  },

  // Level 3: Schaustellen — entered from the Handelswege overview, exit from anywhere inside
  hSalzschifffahrt: {
    loader: () => import("../EntryRoom/states/waypointsHandelswegeSalzschifffahrt.json"),
    parentId: "ThemeM_Handelswege",
    entryAreaId: "MainInfo_Schifffahrt",
    exitAreaId: null,
    downExitAreaId: null,
  },
  hSoleleitung: {
    loader: () => import("../EntryRoom/states/waypointsHandelswegeSoleleitung.json"),
    parentId: "ThemeM_Handelswege",
    entryAreaId: "Handelswege_Soleleitung",
    exitAreaId: null,
    downExitAreaId: null,
  },
  hModernerSalztransport: {
    loader: () => import("../EntryRoom/states/waypointsHandelswegeModernerSalztransport.json"),
    parentId: "ThemeM_Handelswege",
    entryAreaId: "Salztransport",
    exitAreaId: null,
    downExitAreaId: null,
  },
  hModernerSalztransport2: {
    loader: () => import("../EntryRoom/states/waypointsHandelswegeModernerSalztransport.json"),
    parentId: "ThemeM_Handelswege",
    entryAreaId: "Salztransport_Entry2",
    exitAreaId: null,
    downExitAreaId: null,
  },
  hDieStaedte: {
    loader: () => import("../EntryRoom/states/waypointsHandelswegeDieStaedte.json"),
    parentId: "ThemeM_Handelswege",
    entryAreaId: "Handelswege_DieStaedte",
    exitAreaId: null,
    downExitAreaId: null,
  },

  // Level 3: Schaustellen — entered from the Klima overview, exit from anywhere inside
  kBergrutsche: {
    loader: () => import("../EntryRoom/states/waypointsKlimaBergrutsche.json"),
    parentId: "ThemeM_Klima",
    entryAreaId: "MainInfo_Verschuettung",
    exitAreaId: null,
    downExitAreaId: null,
  },
  kBergsturz: {
    loader: () => import("../EntryRoom/states/waypointsKlimaBergsturz.json"),
    parentId: "ThemeM_Klima",
    entryAreaId: "Klima_MainInfo_Bergsturz",
    exitAreaId: null,
    downExitAreaId: null,
  },
  kEiszeitModelle: {
    loader: () => import("../EntryRoom/states/waypointsKlimaEiszeitModelle.json"),
    parentId: "ThemeM_Klima",
    entryAreaId: "MainInfo_EiszeitModelle",
    exitAreaId: null,
    downExitAreaId: null,
  },
  kAlmen: {
    loader: () => import("../EntryRoom/states/waypointsKlimaAlmen.json"),
    parentId: "ThemeM_Klima",
    entryAreaId: "MainInfo_Almen",
    exitAreaId: null,
    downExitAreaId: null,
  },

  // Level 3: Schaustellen — entered from the Holzarbeit overview, exit from anywhere inside
  holzTimeMachine: {
    loader: () => import("../EntryRoom/states/waypointsHolzTimeMachine.json"),
    parentId: "ThemeM_Holzarbeit",
    entryAreaId: "Holzarbeit_Zeitmaschine",
    exitAreaId: null,
    downExitAreaId: null,
  },
  holzHolzImBerg: {
    loader: () => import("../EntryRoom/states/waypointsHolzarbeitHolzImBerg.json"),
    parentId: "ThemeM_Holzarbeit",
    entryAreaId: "MainInfo_HolzImBerg",
    exitAreaId: null,
    downExitAreaId: null,
  },
  holzHolzImTransport: {
    loader: () => import("../EntryRoom/states/waypointsHolzarbeitHolzImTransport.json"),
    parentId: "ThemeM_Holzarbeit",
    entryAreaId: "MainInfo_HolzImTransport",
    exitAreaId: null,
    downExitAreaId: null,
  },
  holzWerkzeuge: {
    loader: () => import("../EntryRoom/states/waypointsHolzarbeitWerkzeuge.json"),
    parentId: "ThemeM_Holzarbeit",
    entryAreaId: "MainInfo_HolzWerkzeuge",
    exitAreaId: null,
    downExitAreaId: null,
  },
  holzHolzarbeit: {
    loader: () => import("../EntryRoom/states/waypointsHolzarbeitHolzarbeit.json"),
    parentId: "ThemeM_Holzarbeit",
    entryAreaId: "Holzarbeit_Schaustelle",
    exitAreaId: null,
    downExitAreaId: null,
  },
  holzPapier: {
    loader: () => import("../EntryRoom/states/waypointsHolzarbeitPapier.json"),
    parentId: "ThemeM_Holzarbeit",
    entryAreaId: "MainInfo_Papier",
    exitAreaId: null,
    downExitAreaId: null,
  },

  ThemeM_MuseenDerRegion: {
    loader: () => import("../EntryRoom/states/waypointsMDR.json"),
    parentId: "EntryRoom",
    entryAreaId: "ThemeM_MuseenDerRegion",
    exitAreaId: null,
    downExitAreaId: null,
  },
};